export default __webpack_public_path__ + "static/media/577.ce4260b8.gif";